import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";

const getToken = () => localStorage.getItem("u_token");

export const fetchCustomer = createAsyncThunk(
    "customer/fetchCustomer",
    async ({ search, page, limit, ...filters }, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}admin/customer`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { search, page, limit, ...filters }
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch customers." });
        }
    }
);

export const addCustomer = createAsyncThunk(
    "customer/addCustomer",
    async (customerData, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.post(`${Apiurl}admin/customer/add`, customerData, {
                headers: { Authorization: `Bearer ${token}` },

            });

            Swal.fire({
                icon: "success",
                title: "Customers",
                text: "Added  successfully",
                timer: 3000,
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to add customer." });
        }
    }
);
export const updateCustomer = createAsyncThunk(
    "customer/updateCustomer",
    async (customerData, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.post(`${Apiurl}admin/customer/update`, customerData, {
                headers: { Authorization: `Bearer ${token}` },

            });
            Swal.fire({
                icon: "success",
                title: "Customers",
                text: "Updated  successfully",
                timer: 3000,
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to update customer." });
        }
    }
);

export const bulkAddCustomer = createAsyncThunk(
    "customer/bulkAddCustomer",
    async (customerData, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.post(`${Apiurl}admin/customer/bulk-upload`, customerData, {
                headers: { Authorization: `Bearer ${token}` },

            });

            Swal.fire({
                icon: "success",
                title: "Customers",
                text: "Upload  successful",
                timer: 3000,
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to add customers in bulk." });
        }
    }
);

export const deleteCustomer = createAsyncThunk(
    "customer/deleteCustomer",
    async (customerId, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}admin/customer/delete/${customerId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            Swal.fire({
                icon: "success",
                title: "Customers",
                text: "Delete  successful",
                timer: 3000,
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to delete customer." });
        }
    }
);


const initialState = {
    customerData: [],
    loading: false,
    getStatus: "idle",
    addStatus: "idle",
    updateStatus: "idle",
    bulkAddStatus: "idle",
    deleteStatus: "idle",
    error: null,
    totalCount: 0,
};

const customerSlice = createSlice({
    name: "customer",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomer.pending, (state) => {
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchCustomer.fulfilled, (state, action) => {
                state.customerData = action.payload.data;
                state.totalCount = action.payload.total;
                state.getStatus = "succeeded";
            })
            .addCase(fetchCustomer.rejected, (state, action) => {
                state.error = action.payload;
                state.getStatus = "failed";
            })
            .addCase(addCustomer.pending, (state) => {
                state.error = null;
                state.addStatus = "pending";
            })
            .addCase(addCustomer.fulfilled, (state, action) => {
                state.addStatus = "succeeded";
            })
            .addCase(addCustomer.rejected, (state, action) => {
                state.error = action.payload;
                state.addStatus = "failed";
            })
            .addCase(updateCustomer.pending, (state) => {
                state.error = null;
                state.updateStatus = "pending";
            })
            .addCase(updateCustomer.fulfilled, (state, action) => {
                state.updateStatus = "succeeded";
            })
            .addCase(updateCustomer.rejected, (state, action) => {
                state.error = action.payload;
                state.updateStatus = "failed";
            })
            .addCase(bulkAddCustomer.pending, (state) => {
                state.error = null;
                state.bulkAddStatus = "pending";
            })
            .addCase(bulkAddCustomer.fulfilled, (state, action) => {
                state.bulkAddStatus = "succeeded";
            })
            .addCase(bulkAddCustomer.rejected, (state, action) => {
                state.error = action.payload;
                state.bulkAddStatus = "failed";
            })
            .addCase(deleteCustomer.pending, (state) => {
                state.error = null;
                state.deleteStatus = "pending";
            })
            .addCase(deleteCustomer.fulfilled, (state, action) => {
                state.deleteStatus = "succeeded";
            })
            .addCase(deleteCustomer.rejected, (state, action) => {
                state.error = action.payload;
                state.deleteStatus = "failed";
            });
    },
});

export default customerSlice.reducer;
